import classNames from 'classnames';
import PropTypes from 'prop-types';

const ChevronRightIcon = ({ className }) => {
  return (
    <svg
      className={classNames('chevron-right-icon', className)}
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path stroke='#D0D5DD' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.333' d='M6 12l4-4-4-4'></path>
    </svg>
  );
};

ChevronRightIcon.propTypes = {
  className: PropTypes.string,
};

export default ChevronRightIcon;
